var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pdfContainer"},_vm._l((_vm.numPages),function(index){return _c('pdf',{key:index,ref:"pdf",refInFor:true,attrs:{"src":_vm.pdfUrl,"page":index}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }